import React from "react";
import { useTranslation } from "react-i18next";

import { Card, CardBody, CardHeader, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";

import PaymentsRow from "./PaymentsRow";

export default function PropertyPaymentsCard({ payments, address, propertyId }) {
	const outstandingPayments = payments.filter((payment) => !payment.paymentDate);
	const paidPayments = payments.filter((payment) => payment.paymentDate);
	const { t } = useTranslation();
	return (
		<Card overflowX={{ sm: "scroll", xl: "hidden" }}>
			<CardHeader>
				<Text fontSize="xl">Address: {address}</Text>
			</CardHeader>
			<CardBody>
				<Table variant="simple" size="sm">
					<Thead>
						<Tr my=".8rem" pl="0px">
							<Th pl="0px">{t("table.issuedDate")}</Th>
							<Th>{t("table.status")}</Th>
							<Th>{t("table.dueDate")}</Th>
							<Th>{t("table.amount")}</Th>
							<Th>{t("table.method")}</Th>
							<Th>{t("table.type")}</Th>
							<Th>{t("table.paidDate")}</Th>
							<Th></Th>
						</Tr>
					</Thead>
					<Tbody>
						{outstandingPayments.map((row, index) => {
							return (
								<PaymentsRow
									id={row.id}
									key={index}
									date={row.issuedDate}
									address={address}
									paymentDate={row.paymentDate}
									code={row.number}
									amount={row.amount}
									type={row.type}
									status={row.paymentDate ? "paid" : "due"}
									logo={row.logo}
									format={row.format}
									method={row.paymentMethod}
									documents={row.documents}
									paymentDirection={row.paymentDirection}
									currency={row.currency}
									propertyId={propertyId}
								/>
							);
						})}
						{paidPayments.map((row, index) => {
							return (
								<PaymentsRow
									id={row.id}
									key={index}
									date={row.issuedDate}
									address={address}
									paymentDate={row.paymentDate}
									code={row.number}
									amount={row.amount}
									type={row.type}
									status={row.paymentDate ? "paid" : "due"}
									logo={row.logo}
									format={row.format}
									method={row.paymentMethod}
									documents={row.documents}
									paymentDirection={row.paymentDirection}
									currency={row.currency}
									propertyId={propertyId}
								/>
							);
						})}
						{outstandingPayments.length === 0 && paidPayments.length == 0 && (
							<Tr>
								<Td colSpan={8}>No payments found</Td>
							</Tr>
						)}
					</Tbody>
				</Table>
			</CardBody>
		</Card>
	);
}
